import React, { Fragment, useEffect, useState } from 'react'
import { Query } from 'react-apollo';
import providersQuery from '../../query';
import MultiSelect from './components/MultiSelect';
import { Modal, ModalBody } from 'reactstrap';
import { FormattedMessage, useIntl } from 'react-intl';
import CreateProviderModal from './components/CreateProviderModal';

const QuerySelect = ({ name, initialValue, updateField, placeholder, isCommercial = false }) => {
  const intl = useIntl();
  const [showCreateProviderModal, setShowCreateProviderModal] = useState(false);
  const [providerName, setProviderName] = useState("");

  const handlerCreateProvider = () => {
    setShowCreateProviderModal(!showCreateProviderModal);
  }

  return (
    <Query 
    query={providersQuery}
    variables={{ 
      isCommercial,
      first: isCommercial ? null : 10
    }}
    >
      {({ loading, data, error, refetch }) => {
        const providers = data?.providers?.edges?.map(({ node }) => ({
          id: node.id,
          value: node.id,
          label: node.name
        }))

        const handleRefetch = (providerName) => {
          setProviderName(providerName);

          refetch({
            search: providerName,
            isCommercial
          })
        }

        if (error) {
          const {graphQLErrors} = error;
          const errorMessage = graphQLErrors[0]?.message;
          console.error("Error fetching providers:", errorMessage);
        }
      
        return (
          <Fragment>
            <MultiSelect
              className="city-select--step1"
              config={{
                name,
                initialValues: initialValue,
                selectValues: providers,
                disabled: loading,
                placeholderMessage: placeholder,
                disabledPlaceholder: intl.formatMessage({ id: "LoadingMessage.label" }),
              }}
              isOnlyOneOption
              updateField={updateField}
              onFilterChange={handleRefetch}
              handlerCreateProvider={handlerCreateProvider}
              withoutCreateProvider={isCommercial}
            />

            <CreateProviderModal
              providerName={providerName}
              fieldName={name}
              showCreateProviderModal={showCreateProviderModal}
              handlerCreateProvider={handlerCreateProvider}
              refetch={refetch}
              updateField={updateField}
            />
          </Fragment>
        );
      }}
    </Query>
  )
}

export default QuerySelect;
